import axiosConfig from "../../../utils/axiosConfig";

const chartUrl = "pages/draft_and_declines/draft_chart";
const filtersUrl = "pages/draft_and_declines/draft_chart/filters";

export const api = {
  getValues(params) {
    return axiosConfig.get(chartUrl, params);
  },
  getFilters(params) {
    return axiosConfig.get(filtersUrl, params);
  }
};
